import { TableDataContent, TableContent } from '../../interfaces/ContentBlock';

export const parseTableContent = (tableContent: TableDataContent): TableContent[] => {
  return Object.keys(tableContent).map((k) => {
    return {
      title: tableContent[k].title(),
      secondColumn: tableContent[k].second_column(),
      thirdColumn: tableContent[k].third_column(),
      hasCircle: tableContent[k].hasCircle?.(),
    };
  });
};
